class CustomerAuth extends HTMLElement {
    constructor() {
        super();

        this.auth = this;
        this.authScrollY = 0;
        this.authScrollLocked = false;
        this.bodyScrollLockStyles = null;

        if(document.querySelector('[data-open-auth-popup]')){
            document.querySelectorAll('[data-open-auth-popup]').forEach((openPopup) =>
                openPopup.addEventListener('click', this.setOpenPopup.bind(this))
            );
        }

        if(document.querySelector('[data-close-auth-popup]')){
            document.querySelector('[data-close-auth-popup]').addEventListener(
                'click',
                this.setClosePopup.bind(this)
            );
        }

        if(document.querySelector('[data-open-auth-sidebar]')){
            document.querySelectorAll('[data-open-auth-sidebar]').forEach((openSidebar) =>
                openSidebar.addEventListener('click',this.setOpenSidebar.bind(this))
            );
        }

        if(document.querySelector('[data-close-auth-sidebar]')){
            document.querySelector('[data-close-auth-sidebar]').addEventListener(
                'click',
                this.setCloseSidebar.bind(this)
            );
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    setOpenPopup(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
        } else {
            document.body.classList.add('auth-popup-show');
        }
    }

    setClosePopup(event){
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove('auth-popup-show');
    }

    setOpenSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
        } else {
            document.body.classList.add('auth-sidebar-show');
            this.lockPageScroll();
        }
    }

    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove('auth-sidebar-show');
        this.unlockPageScroll();
    }

    lockPageScroll(){
        if (this.authScrollLocked) return;

        const body = document.body;
        const root = document.documentElement;
        const properties = ['position', 'top', 'left', 'right', 'width'];

        this.authScrollY = window.scrollY || window.pageYOffset || root.scrollTop || 0;
        this.bodyScrollLockStyles = properties.reduce((styles, property) => {
            styles[property] = {
                value: body.style.getPropertyValue(property),
                priority: body.style.getPropertyPriority(property)
            };
            return styles;
        }, {});

        root.classList.add('auth-scroll-locked');
        body.style.setProperty('position', 'fixed', 'important');
        body.style.setProperty('top', `-${this.authScrollY}px`, 'important');
        body.style.setProperty('left', '0', 'important');
        body.style.setProperty('right', '0', 'important');
        body.style.setProperty('width', '100%', 'important');
        this.authScrollLocked = true;
    }

    unlockPageScroll(){
        if (!this.authScrollLocked) return;

        const body = document.body;
        const root = document.documentElement;

        Object.entries(this.bodyScrollLockStyles || {}).forEach(([property, style]) => {
            if (style.value) {
                body.style.setProperty(property, style.value, style.priority);
            } else {
                body.style.removeProperty(property);
            }
        });

        root.classList.remove('auth-scroll-locked');
        this.authScrollLocked = false;
        this.bodyScrollLockStyles = null;
        window.scrollTo(0, this.authScrollY);
    }
    
    onBodyClickEvent(event){
        if(document.body.classList.contains('auth-popup-show')){
            if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-auth-popup]').length === 0)){
                this.setClosePopup(event);
            }
        }
        
        if(document.body.classList.contains('auth-sidebar-show')){
            if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-auth-sidebar]').length === 0) && ($(event.target).closest('[data-auth-sidebar]').length === 0)){
                event.stopImmediatePropagation();
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('customer-auth', CustomerAuth);
